import React, { useState } from "react";
import {
  materialRenderers,
  materialCells,
} from "@jsonforms/material-renderers";
import { JsonForms } from "@jsonforms/react";
import Navbar from "../components/Navbar";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-quill/dist/quill.snow.css"; // Стили для редактора
import ReactQuill from "react-quill";

const schema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  title: "Generated schema for Root",
  type: "object",
  properties: {
    table: {
      type: "array",
      items: {
        type: "object",
        oneOf: [
          {
            title: "TemplateOne",
            properties: {
              type: { type: "string", const: "TemplateOne" },
              title: {
                type: "string",
                const: "Раздел 1. Сведения о количестве граждан",
              },
              headers: {
                type: "array",
                items: {
                  type: "array",

                  items: {
                    type: "object",
                    properties: {
                      text: { type: "string" },
                      rowSpan: { type: "integer" },
                      colSpan: { type: "integer" },
                    },
                    required: ["text", "rowSpan", "colSpan"],
                  },
                },
              },
              rows: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    rowNumber: { type: "integer" },
                    description: { type: "string" },
                    values: { type: "array", items: { type: "string" } },
                  },
                  required: ["rowNumber", "description", "values"],
                },
              },
              rules: {
                type: "array",
                items: {
                  type: "object",
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                      enum: ["disabled", "sum", "gte", "mixing"],
                    },
                  },
                  oneOf: [
                    {
                      title: "Disabled Rule",
                      properties: {
                        type: { const: "disabled" },
                        target: { type: "string" },
                      },
                      required: ["type", "target"],
                    },
                    {
                      title: "Sum Rule",
                      properties: {
                        type: { const: "sum" },
                        target: { type: "string" },
                        sources: { type: "array", items: { type: "string" } },
                      },
                      required: ["type", "target", "sources"],
                    },
                    {
                      title: "GTE Rule",
                      properties: {
                        type: { const: "gte" },
                        target: { type: "string" },
                        sources: { type: "array", items: { type: "string" } },
                      },
                      required: ["type", "target", "sources"],
                    },
                    {
                      title: "Mixing Rule",
                      properties: {
                        type: { const: "mixing" },
                        target: { type: "string" },
                        source: { type: "string" },
                      },
                      required: ["type", "target", "source"],
                    },
                  ],
                },
              },
            },
            required: ["type", "title", "headers", "rows"],
          },
          {
            title: "TemplateTwo",
            properties: {
              type: { type: "string", const: "TemplateTwo" },

              title: { type: "string", const: "Раздел ОТД" },
              headers: {
                type: "array",
                items: {
                  type: "array",
                  items: {
                    type: "object",
                    properties: {
                      text: { type: "string" },
                      rowSpan: { type: "integer" },
                      colSpan: { type: "integer" },
                    },
                    required: ["text", "rowSpan", "colSpan"],
                  },
                },
              },
              rows: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    rowNumber: { type: "integer" },
                    description: { type: "string" },
                    values: { type: "array", items: { type: "string" } },
                  },
                  required: ["rowNumber", "description", "values"],
                },
              },
              rules: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                      enum: ["disabled", "sum", "gte", "mixing"],
                    },
                  },
                  oneOf: [
                    {
                      title: "Disabled Rule",
                      properties: {
                        type: { const: "disabled" },
                        target: { type: "string" },
                      },
                      required: ["type", "target"],
                    },
                    {
                      title: "Sum Rule",
                      properties: {
                        type: { const: "sum" },
                        target: { type: "string" },
                        sources: { type: "array", items: { type: "string" } },
                      },
                      required: ["type", "target", "sources"],
                    },
                    {
                      title: "GTE Rule",
                      properties: {
                        type: { const: "gte" },
                        target: { type: "string" },
                        sources: { type: "array", items: { type: "string" } },
                      },
                      required: ["type", "target", "sources"],
                    },
                    {
                      title: "Mixing Rule",
                      properties: {
                        type: { const: "mixing" },
                        target: { type: "string" },
                        source: { type: "string" },
                      },
                      required: ["type", "target", "source"],
                    },
                  ],
                },
              },
            },
            required: ["type", "title", "headers", "rows"],
          },
          {
            title: "TemplateThree",
            properties: {
              type: { type: "string", const: "TemplateThree" },

              title: { type: "string", const: "Раздел I. Юридическая помощь" },
              headers: {
                type: "array",
                items: {
                  type: "array",
                  items: {
                    type: "object",
                    properties: {
                      text: { type: "string" },
                      rowSpan: { type: "integer" },
                      colSpan: { type: "integer" },
                    },
                    required: ["text", "rowSpan", "colSpan"],
                  },
                },
              },
              rows: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    rowNumber: { type: "integer" },
                    description: { type: "string" },
                    values: { type: "array", items: { type: "string" } },
                  },
                  required: ["rowNumber", "description", "values"],
                },
              },
              rules: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                      enum: ["disabled", "sum", "gte", "mixing"],
                    },
                  },
                  oneOf: [
                    {
                      title: "Disabled Rule",
                      properties: {
                        type: { const: "disabled" },
                        target: { type: "string" },
                      },
                      required: ["type", "target"],
                    },
                    {
                      title: "Sum Rule",
                      properties: {
                        type: { const: "sum" },
                        target: { type: "string" },
                        sources: { type: "array", items: { type: "string" } },
                      },
                      required: ["type", "target", "sources"],
                    },
                    {
                      title: "GTE Rule",
                      properties: {
                        type: { const: "gte" },
                        target: { type: "string" },
                        sources: { type: "array", items: { type: "string" } },
                      },
                      required: ["type", "target", "sources"],
                    },
                    {
                      title: "Mixing Rule",
                      properties: {
                        type: { const: "mixing" },
                        target: { type: "string" },
                        source: { type: "string" },
                      },
                      required: ["type", "target", "source"],
                    },
                  ],
                },
              },
            },
            required: ["type", "title", "headers", "rows"],
          },
          {
            title: "TemplateFour",
            properties: {
              type: { type: "string", const: "TemplateFour" },

              headers: {
                type: "array",
                items: {
                  type: "array",
                  items: {
                    type: "object",
                    properties: {
                      text: { type: "string" },
                      rowSpan: { type: "integer" },
                      colSpan: { type: "integer" },
                    },
                    required: ["text", "rowSpan", "colSpan"],
                  },
                },
              },
              rows: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    rowNumber: { type: "integer" },
                    description: { type: "string" },
                    values: { type: "array", items: { type: "string" } },
                  },
                  required: ["rowNumber", "description", "values"],
                },
              },
              rules: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                      enum: ["disabled", "sum", "gte", "mixing"],
                    },
                  },
                  oneOf: [
                    {
                      title: "Disabled Rule",
                      properties: {
                        type: { const: "disabled" },
                        target: { type: "string" },
                      },
                      required: ["type", "target"],
                    },
                    {
                      title: "Sum Rule",
                      properties: {
                        type: { const: "sum" },
                        target: { type: "string" },
                        sources: { type: "array", items: { type: "string" } },
                      },
                      required: ["type", "target", "sources"],
                    },
                    {
                      title: "GTE Rule",
                      properties: {
                        type: { const: "gte" },
                        target: { type: "string" },
                        sources: { type: "array", items: { type: "string" } },
                      },
                      required: ["type", "target", "sources"],
                    },
                    {
                      title: "Mixing Rule",
                      properties: {
                        type: { const: "mixing" },
                        target: { type: "string" },
                        source: { type: "string" },
                      },
                      required: ["type", "target", "source"],
                    },
                  ],
                },
              },
            },
            required: ["type", "headers", "rows"],
          },
        ],
      },
    },
  },
};

const initialData = {};

function FormNew(props) {
  const [data, setData] = useState(initialData);
  const [formName, setFormName] = useState("");
  const [shortFormName, setShortFormName] = useState("")
  const [information, setInformation] = useState("");
  const [header, setHeader] = useState("");
  const [isVisible, setIsVisible] = useState(true);
  const [isCanceled, setIsCanceled] = useState(false);
  const [formType, setFormType] = useState("main_report"); // 'main_report' или 'summary_report'

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const combinedData = {
        form_name: formName,
        short_name: shortFormName,
        information,
        header,
        isVisible,
        isCanceled,
        formType,
        ...data,
      };

      const response = await fetch("/forms", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(combinedData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Ошибка при отправке данных");
      }
      toast.success("Форма успешно отправлена");
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="min-h-full bg-gray-50">
        <div className="pb-32">
          <Navbar props={props} />

          {/* Заголовок */}
          <header className="py-12">
            <div className="mx-auto container max-w-screen-2xl px-4">
              <h1 className="text-3xl font-semibold tracking-tight text-black">
                Новая форма
              </h1>
            </div>
          </header>
        </div>

        {/* Основной контент */}
        <main className="-mt-32">
          <div className="mx-auto container max-w-screen-2xl pb-12">
            <div className="overflow-hidden px-5 py-5 rounded-lg bg-white shadow-lg">
              <form onSubmit={handleSubmit}>
                {/* Существующие поля */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Название формы
                  </label>
                  <input
                    type="text"
                    value={formName}
                    onChange={(e) => setFormName(e.target.value)}
                    className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Короткое Название формы
                  </label>
                  <input
                    type="text"
                    value={shortFormName}
                    onChange={(e) => setShortFormName(e.target.value)}
                    className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Срок представления и тд
                  </label>
                  <ReactQuill value={information} onChange={setInformation} />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Шапка
                  </label>
                  <ReactQuill value={header} onChange={setHeader} />
                </div>

                {/* Новые поля */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Видимость
                  </label>
                  <input
                    type="checkbox"
                    checked={isVisible}
                    onChange={(e) => setIsVisible(e.target.checked)}
                    className="mt-1"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Отменён
                  </label>
                  <input
                    type="checkbox"
                    checked={isCanceled}
                    onChange={(e) => setIsCanceled(e.target.checked)}
                    className="mt-1"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Тип формы
                  </label>
                  <select
                    value={formType}
                    onChange={(e) => setFormType(e.target.value)}
                    className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="main_report">Основной отчёт</option>
                    <option value="summary_report">Сводный отчёт</option>
                  </select>
                </div>
            
                <button
                  className="block mt-5 px-4 py-2 rounded bg-blue-600 text-white"
                  type="submit"
                >
                  Отправить
                </button>
              </form>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default FormNew;
